// KTT Generate HTML Tables
// ======================================================
import * as utils from "./misc";
import * as data from "../log/ktt-data.js";
import * as time from "./time";
import * as unit from "./units";
import { countHabitTotals } from "../log/entries/entries.js";

export function HTML_entryPill(entryObj) {
  return `
    <div class="entry-summary-pill">
      <div class="entryComment pill">${data.parseComments(entryObj.comment)}</div>
      <div class="entryDuration pill">${time.minsToHM(entryObj.duration)}</div>

      ${HTML_rhythm_widget(entryObj).outerHTML}

      <div class='startEndTime pill'>
        <label>Start:</label> <val>${entryObj.start}</val>
        <label>End:</label>   <val>${entryObj.end}</val>
      </div>

    </div>
  `;
}

export function HTML_rhythm_widget(entryObj) {
  const entryRhythmDiv = document.createElement("div");
  entryRhythmDiv.classList.add("entryRhythm", "pill");

  if (entryObj?.rhythm?.mood) {
    entryRhythmDiv.append(HTML_val_segment(entryObj.rhythm.mood, "mood"));
  }

  if (entryObj?.rhythm?.energy) {
    entryRhythmDiv.append(HTML_val_segment(entryObj.rhythm.energy, "energy"));
  }

  if (entryObj?.rhythm?.clarity) {
    entryRhythmDiv.append(HTML_val_segment(entryObj.rhythm.clarity, "clarity"));
  }

  return entryRhythmDiv;
}

export function HTML_val_segment(rhythmValue, type) {
  const valSegment = document.createElement("val");
  valSegment.setAttribute("level", rhythmValue);
  valSegment.setAttribute("type", type);
  valSegment.textContent = rhythmValue;
  return valSegment;
}

export function HTML_start_and_end_time_popup(entryObj) {
  return `
    <div type="popup">
      <label>Start:</label> <val>${entryObj.start}</val>
      <label>End:</label>   <val>${entryObj.end}</val>
    </div>
    `;
}

export function HTML_EntriesPills(dayObj = {}, tag_name) {
  return dayObj.entries
    .filter((entry) => entry.tags.includes(tag_name))
    .map((entry) => HTML_entryPill(entry))
    .join("");
}

export function HTML_EntriesTable(tagObj, dates) {
  return `
    <table class="entries">
      <tr class="header" style='display: none'>
        <th>Date</th><th>Entries</th><th>Total</th><th>x</th>
      </tr>
      ${HTML_EntriesTable_data(tagObj, dates)}
    </table>
  `;
}

export function HTML_EntriesTable_data(tagObj, dates = tagObj.datesSinceFirstTag) {
  // todo:
  //  1. have goal and tag Obj both share the same dates object, so this function can receive either as param1.
  //  2. the columns/headers for these tables can be defined in a single object that also gets passed into all of them

  // Main Table
  let html = HTML_EntriesTable_data_main_table(tagObj, dates);

  // Headers
  html = HTML_EntriesTable_data_final_headers(tagObj, dates, html);

  return html;
}

export function HTML_EntriesTable_data_main_table(tagObj, dates = tagObj.datesSinceFirstTag) {
  return dates
    .map((dayObj) => {
      let html = [];
      // Month header for last day of month
      if (time.isLastDay(new Date(dayObj[0]))) {
        html.push(HTML_EntriesTable_month(dayObj[1], tagObj.name));
      }
      // Week header for last day of week
      if (dayObj[1].date.day == 0) {
        html.push(HTML_EntriesTable_week(dayObj[1], tagObj.name, dates));
      }
      // if its a normal day
      html.push(HTML_EntriesTable_day(dayObj[1], tagObj.name));
      return html.join("");
    })
    .reverse();
}

export function HTML_EntriesTable_data_final_headers(tagObj, dates = tagObj.datesSinceFirstTag, html) {
  // add month and week headers to beginning of table
  let lastDay = dates[dates.length - 1][1];

  if (!html[0].includes('class="week title') || html[0].includes('class="month title')) {
    html.unshift(HTML_EntriesTable_week(lastDay, tagObj.name));
  }
  if (!html[0].includes('class="month title')) {
    html.unshift(HTML_EntriesTable_month(lastDay, tagObj.name));
  }
  return html.join("");
}

export function HTML_EntriesTotals(dayObj, tag_name, period = "day") {
  let filteredData = [];
  let totalsTCHA;
  let datesList;

  switch (period) {
    case "day":
      filteredData = Object.entries(dayObj.habits).filter((x) => x[0] == tag_name);
      if (filteredData.length == 0) {
        return "";
      }
      filteredData = filteredData[0][1].data;
      break;

    case "week":
      datesList = window.logFile.Years[dayObj.date.year][dayObj.date.month + 1][dayObj.date.week];
      // if ( dayObj.date.year  == 2023 && dayObj.date.month == 2) {
      // console.log(`Week Summary: (${tag_name})`, datesList)
      // }
      break;

    case "month":
      let month = window.logFile.Years[dayObj.date.year][dayObj.date.month + 1];
      delete month.summary;
      datesList = Object.assign({}, ...Object.values(month));
      break;
  }

  if (period == "week" || period == "month") {
    // console.log('filteredData:', filteredData)
    delete datesList.summary;

    Object.entries(datesList).forEach((day) => {
      let habits = Object.entries(day)[1][1].habits;

      if (habits && Object.keys(habits).length != 0 && habits[tag_name]) {
        habits[tag_name].data.forEach((entry) => filteredData.push(entry.data));
      }
    });

    // here need to handle the recursive case.
    totalsTCHA = filteredData.map((key) => countHabitTotals(key));
  } else {
    totalsTCHA = filteredData.map((key) => countHabitTotals(key.data));
  }

  // console.log('totalsTCHA before: ', totalsTCHA)
  totalsTCHA = data.mergeTCHA(totalsTCHA);
  // console.log('totalsTCHA after Merge: ', totalsTCHA)

  return totalsTCHA.length == 0 ? "<div nodata></div>" : HTML_keylist_group(totalsTCHA, tag_name);
}

export function HTML_EntriesTable_day(dayObj, tag_name) {
  const length = utils.filterDayObjByTag(dayObj, tag_name).length;

  // based on tag name we can append different sessions types.

  let entriesWrapper = "";
  if (length > 0) {
    entriesWrapper = `
    <div class="entries-wrapper" length="${length}">

        <div class="entries-totals">
          ${HTML_EntriesTotals(dayObj, tag_name, "day")}
        </div>

        <div class="entries-each">
          <div class='title'>Sessions</div>
          ${HTML_EntriesPills(dayObj, tag_name)}
        </div>

      </div>
    `;
  }

  return `
    <tr year="${dayObj.date.year}" month="${dayObj.date.moNameShort}" class="day-row collapsible">

      <td class="date">
        ${dayObj.date.dayNameShort} ${dayObj.date.date}
      </td>

      <td entries colspan="2">${entriesWrapper}</td>

      <td class="time">
        ${time.minsToHM(dayObj.summary[tag_name])}
      </td>

    </tr>
    `;
}

export function HTML_EntriesTable_week(dayObj, tag_name, dates = "") {
  let total = "";
  // let total = dayObj.summary[tag_name]
  // total = total ? `${total} mins` : ''

  // console.error(dayObj)
  // let totals = Object.entries(dayObj).filter(x => {
  //   Object.entries(x.entries).entries
  // })
  // console.log('totals week', dayObj.date.year, dayObj.date.week)
  return `

    <tr class="week title summary"
      year="${dayObj.date.year}"
      month="${dayObj.date.moNameShort}"
      tag="${tag_name}"
    >
      <th colspan="4">
        <h5>Week ${dayObj.date.week} - <span class='advice'>Weekly volume is crucial. Ideally 10-20 sets per muscle group</span></h5>
      </th>

    </tr>

    <tr class="week summary collapsible"
      year="${dayObj.date.year}"
      month="${dayObj.date.weekNo}"
      tag="${tag_name}"
    >

      <th colspan="4">

        <div class="data-wrap">

          <div class="data-block">
            <h4>Summary</h4>
            <div class="dataHabitWrapper habitsummary">
              <div class='keylistWrapper'>

                ${HTML_EntriesTotals(dayObj, tag_name, "week")}

              </div>
            </div>
          </div>

          <div class="data-block" style="display: none">
            <h4>Comparison</h4>
            <div class="dataHabitWrapper habitcomparison">
            </div>
          </div>

        </div>

      </th>

    </tr>
    `;
}

export function HTML_EntriesTable_month(dayObj, tag_name) {
  // if ( dayObj['date']['year'] === 2023) {
  // console.log('HTML_EntriesTable_month(): =========')
  // console.log(dayObj)
  // }

  const queryString = `tr[month=\'${dayObj.date.moNameShort}\'][year=\'${dayObj.date.year}\'].collapsible:not(.month.summary)`;

  return `
    <tr year="${dayObj.date.year}" month="${dayObj.date.moNameShort}" class="month title summary" tag="${tag_name}">
      <th colspan="4">
        <h4 onclick="toggleClassAll(\`${queryString}\`, 'collapsed')">${dayObj.date.moName} ${dayObj.date.year}</h4>
      </th>
    </tr>

    <tr year="${dayObj.date.year}" month="${dayObj.date.moNameShort}" class="month summary collapsible">
      <th colspan="4">

        <div class="data-wrap">

          <div class="data-block">
            <h4>Summary</h4>
            <div class="dataHabitWrapper habitsummary">
              <div class='keylistWrapper'>
                ${HTML_EntriesTotals(dayObj, tag_name, "month")}
              </div>
            </div>
          </div>

          <div class="data-block" style="display: none">
            <h4>Comparison</h4>
            <div class="dataHabitWrapper habitcomparison">

            </div>
          </div>

        </div>
      </th>
    </tr>

  `;
}

export function filterHabitByTag(habit_summary_obj, tag_name) {
  return Object.entries(habit_summary_obj)
    .filter((habit) => {
      if (habit[0] == tag_name) return habit;
    })
    .map((habit) => habit);
}

export function printHTMLHabitData(habit_data) {
  // console.error(habit_data)
  return habit_data.map((keylist) => HTML_keylist_group(keylist[1]));
}

export function HTML_keylist_group(keylist) {
  // prints out the final HTML of all the key-val pairs

  const sortedKeys = Object.entries(keylist).sort().reverse();

  const html = sortedKeys.map((key) => HTML_keylist(key)).join("");
  return html;
}

export function HTML_keylist(obj) {
  // console.log('HTML_keylist obj:')
  // console.log(obj)

  // for non nested: array ["key_name", "{... total, count, avg...}"]
  // for nested: Array [ "16kg", {…} ]
  // 0: "16kg"
  // 1: Object { goblet_squat: {…}, swings_2hand: {…}, swings_1hand: {…}, … }
  // goblet_squat: Object { total: 50, highest: 10, avg: 10, … }
  // lifts: Object { total: 50, highest: 10, avg: 10, … }
  // swings_1hand: Object { total: 12, highest: 12, avg: 12, … }
  // swings_2hand: Object { total: 25, highest: 25, avg: 25, … }
  // console.log('HTML_keylist() : ')
  // console.log(obj)

  // [
  //   "20kg",
  //   {
  //     "total": null,
  //     "highest": null,
  //     "avg": null,
  //     "count": null
  //   }
  // ]

  // [
  //   "pushups",
  //   {
  //     "total": 82,
  //     "highest": 52,
  //     "avg": 41,
  //     "count": 2
  //   }
  // ]

  if (!obj[1].hasOwnProperty("total")) {
    return `
      <div class="key-list">
        <dl>

          <dt name="${obj[0]}">
            <label name="${obj[0]}">${obj[0]}:</label>
          </dt>

          ${Object.entries(obj[1])
            .map(
              (x) => `
                  <dd name="${x[0]}">
                    <key name="${x[0]}">${x[0]}:</key>
                    ${HTML_keyvals(x[1])}
                  </dd>
                  `,
            )
            .join("")}

        </dl>
      </div>
    `;
  } else {
    // console.log('key-list obj ', obj)

    return `
      <div class="key-list">
        <dl>

          <dt name="${obj[0]}"><label name="${obj[0]}">${obj[0]}:</label></dt>
          <dd>${HTML_keyvals(obj[1])}</dd>

        </dl>
      </div>
    `;
  }
}

export function HTML_keyvals(obj, kv = "val") {
  // Haven't checked, i think this is what it does:
  //  - pass in an obj, specify if its a key or a val to get that back.
  return kv == "key"
    ? `<dt><label name="${obj}">${obj}:</label></dt>`
    : `<div class='tcha'>
        ${Object.entries(obj)
          .map(
            (x) => `<div key="${x[0]}">
                      <key name="${x[0]}">${x[0]}:</key>
                      <val unit="${unit.getUnitType(x[0])}">${unit.showUnit(x[1], x[0])}</val>
                    </div>`,
          )
          .join("")}
      </div>`;
}
